<template>
  <v-col class="register default-slot" md="7" sm="12">
    <div class="top-icons">
      <router-link class="back-icon" to="/">
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back to home
      </router-link>
    </div>
    <h1 class="register-title mb-3">Renew Affiliate</h1>
    <h3 class="mb-7">Affiliate Info - {{ affiliateInfo.name }}</h3>
    <v-form class="register-form">
      <v-row>
        <v-col>
          <p class="text-left">
            <b>Email: </b> {{ affiliateInfo.contact.email }} <br />
            <b>ASCA Member ID: </b> {{ affiliateInfo.memberId }} <br />
            <b>Phone: </b> {{ affiliateInfo.contact.phoneNumber }} <br />
            <b>Address: </b>
            <span>
              {{ affiliateInfo.contact.address }} <br />
              {{ affiliateInfo.contact.city }}
              {{ affiliateInfo.contact.state }}
              {{ affiliateInfo.contact.zipCode }}</span
            ><br />
          </p>
        </v-col>
        <v-col>
          <v-text-field
            outlined
            v-model="affiliateInfo.clubSite"
            label="Affiliate Website"
            :rules="[validateWebsite]"
          />
          <br />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p>
            Please list all educational events and breed activities sponsored by
            your club during this year.
          </p>
          <v-textarea
            outlined
            v-model="affiliateInfo.eventsAndActivities"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-form>
    <v-btn
      class="white--text"
      large
      v-on:click="
        changePage(2);
        changeFirstPageInfo(
          affiliateInfo.website,
          affiliateInfo.eventsAndActivities
        );
      "
      :disabled="!affiliateInfo.eventsAndActivities"
      color="primary"
      >NEXT</v-btn
    >
    <p class="steps">STEP <b>1</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import FooterText from "@/components/common/FooterText.vue";
export default Vue.extend({
  components: { FooterText },
  name: "AffiliateWebsiteAndEvents",
  props: {
    affiliateInfo: Object,
    changePage: Function,
    changeFirstPageInfo: Function,
  },
  methods: {
    validateWebsite(input: string) {
      return (
        /^[-a-zA-Z0-9@:%._/\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
          input
        ) || input === '' || "Website is invalid"
      );
    },
  },
});
</script>